export function isDeveloperConsolePage(): boolean {
    return typeof window !== 'undefined' && (window.location.pathname === '/developer-console' || window.location.pathname.startsWith('/developer-console/'));
}
export function isOpsPage(): boolean {
    return typeof window !== 'undefined' && (window.location.pathname === '/ops' || window.location.pathname.startsWith('/ops/'));
}
export function getApiBase(): string {
    if (typeof window === 'undefined') return process.env.NEXT_PUBLIC_API_URL || '';
    if (isDeveloperConsolePage()) return '/api/developer-console/proxy';
    if (isOpsPage()) return '/api/ops/proxy';
    return '/api/proxy';
}
